import { Component, OnInit } from '@angular/core';
import { Spinkit } from 'ng-http-loader';
import { BasePageComponent } from '../base-page';
import { Store } from "@ngrx/store";
import { IAppState } from "../../interfaces/app-state";
import { HttpService } from "../../services/http/http.service";
import { MainService } from '../main/main.service';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-master-restaurant',
  templateUrl: './master-restaurant.component.html',
  styleUrls: ['./master-restaurant.component.scss'],
  providers: [MainService],
})
export class MasterRestaurantComponent extends BasePageComponent implements OnInit  {
  public spinkit = Spinkit;
  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    private router: Router
  ) { 
    super(store, httpSv);
    this.pageData = {
      title: "",
      loaded: true,
      breadcrumbs: [
        {
          title: "Main",
        },
      ],
    };
  }
  
  ngOnInit(): void {
    this.getMasterRestaurantDtls();
  }

  ngOnDestroy(): void {
  }
  userID: any;
  restaurant = {
    name: 'Tandoori Hub',
    email: 'contact@tandoorihub.com',
    phone: '+1 234 567 8901'
  };

  assignedRestaurants = [
   
  ];

  navigateTo(restaurantId: number) {
    localStorage.setItem("restoID", restaurantId.toString());
    this.httpSv.getTokenRestaurant({restaurant_id:restaurantId}).subscribe((res:any) => {
      if(res['status']){
        localStorage.setItem("access_token", res.token);
        localStorage.setItem("master_user", 'true');
        this.router.navigate(["horizontal/main"]);
      }
    })
    console.log('Navigating to restaurant ID:', restaurantId);
    // Implement navigation logic here (e.g., router.navigate)
  }



  getMasterRestaurantDtls() {
    let data = JSON.parse(sessionStorage.getItem("master_user_data"))
    console.log(data)
    if(!data){
      this.router.navigate(["/"])
      return;
    } 

    localStorage.setItem('access_token', data.authToken);
    
    this.restaurant.name = data.userDetails.dtls.master_resto_name;
    this.restaurant.email = data.userDetails.dtls.email;
    this.restaurant.phone = data.userDetails.dtls.number;

    console.log(this.restaurant)

    this.assignedRestaurants = data.userDetails.assigned.map((ele:any) => {
      return {
        id: ele.restaurant_id,
        name: ele.restaurant_name,
        email: ele.restaurant_email,
        uniqueID: ele.restaurant_unique_id
      }
    });
    
  }


  logout() {
    this.router.navigate(["/"])
  }

}
